export type CompanyDomain = 'ERS' | 'DPS';
export enum CompanyDomainEnum {
  ERS = 'ERS',
  DPS = 'DPS',
}
